<template>
    <div
        :id="mapName"
        class="google-map"></div>
</template>

<script>
    import GoogleMapsLoader from 'google-maps';

    export default {
        props: {
            name: {
                type: String,
                default: '',
            },
            position: {
                type: Object,
                default() {
                    return { latitude: '', longitude: '' };
                },
            },
        },
        data() {
            return {
                mapName: `${this.name}-map`,
                map: null,
                marker: null,
            };
        },
        watch: {
            position() {
                this.PositionChanged();
            },
        },
        mounted() {
            this.PositionChanged();
        },
        methods: {
            PositionChanged() {
                if (!this.position || !this.position.latitude || !this.position.longitude) {
                    return;
                }
                GoogleMapsLoader.KEY = 'AIzaSyC9FMzT6eDKWWcFtPRCMdyVgRiKW0fPBn0';
                GoogleMapsLoader.load((google) => {
                    if (!this.map) {
                        const element = document.getElementById(this.mapName);
                        const options = {
                            disableDefaultUI: true,
                        };
                        this.map = new google.maps.Map(element, options);
                    }
                    this.map.setZoom(15);
                    this.map.panTo({ lat: this.position.latitude - 0.006, lng: this.position.longitude });
                    const newLatLonPosition = new google.maps.LatLng(this.position.latitude, this.position.longitude);
                    if (this.marker) {
                        this.marker.setMap(null); // Remvoe earlier marker
                    }
                    this.marker = new google.maps.Marker({ position: newLatLonPosition, map: this.map });
                });
            },
        },
    };
</script>
